"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../../theme"));
const useStyles = (0, _styles.makeStyles)({
  dayWrapper: {
    minWidth: _theme.default.typography.pxToRem(50),
    '&.wrapper-type-enabled': {
      backgroundColor: '#FFF'
    },
    '&.wrapper-type-disabled': {
      backgroundColor: '#FFF'
    },
    '&.wrapper-type-not-selectable': {
      cursor: 'not-allowed'
    },
    '&.wrapper-type-inRange': {
      backgroundColor: '#E1ECFA'
    },
    '&.wrapper-type-start': {
      background: 'linear-gradient(90deg, #FFF 50%, #E1ECFA 50%)'
    },
    '&.wrapper-type-end': {
      background: 'linear-gradient(-90deg, #FFF 50%, #E1ECFA 50%) !important'
    },
    [_theme.default.breakpoints.down(410)]: {
      minWidth: _theme.default.typography.pxToRem(35)
    }
  },
  dayButton: {
    fontFamily: _theme.default.typography.proxima.regular,
    fontSize: _theme.default.typography.pxToRem(16),
    lineHeight: _theme.default.typography.pxToRem(25),
    width: _theme.default.typography.pxToRem(50),
    height: _theme.default.typography.pxToRem(50),
    borderRadius: '50%',
    cursor: 'pointer',
    border: 0,
    padding: 0,
    outline: 'unset',
    '&.button-type-enabled': {
      backgroundColor: '#FFF',
      color: '#005EDC'
    },
    '&.button-type-disabled': {
      backgroundColor: '#FFF',
      color: '#979797'
    },
    '&.button-type-not-selectable': {
      pointerEvents: 'none'
    },
    '&.button-type-inRange': {
      backgroundColor: '#E1ECFA',
      color: '#005EDC'
    },
    '&.button-type-start': {
      backgroundColor: '#4D99FF',
      color: '#FFF'
    },
    '&.button-type-end': {
      backgroundColor: '#4D99FF',
      color: '#FFF'
    },
    [_theme.default.breakpoints.down('xs')]: {
      width: _theme.default.typography.pxToRem(48),
      height: _theme.default.typography.pxToRem(48)
    }
  },
  underscore: {
    width: _theme.default.typography.pxToRem(20),
    height: _theme.default.typography.pxToRem(3),
    background: '#061556',
    borderRadius: '10px',
    margin: 'auto',
    [_theme.default.breakpoints.down(410)]: {
      width: _theme.default.typography.pxToRem(15),
      height: _theme.default.typography.pxToRem(3),
      margin: 'auto'
    }
  }
});
var _default = exports.default = useStyles;